import { useEffect } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { legalDocuments } from "../data/legalContent";
import Breadcrumbs from "./Breadcrumbs";

export default function LegalPage({ type = "privacy" }) {
  const legalDoc = legalDocuments[type] || legalDocuments.privacy;

  useEffect(() => {
    window.document.title = `${legalDoc.title} | Cullath`;
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [legalDoc.title]);

  return (
    <div className="legal-page">
      <SiteHeader isHeroPage />

      <main className="legal-main">
        <header className="legal-title-block">
          <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: legalDoc.title }]} />
          <p>CULLATH LEGAL</p>
          <h1>{legalDoc.title}</h1>
          <div className="legal-dates">
            <span>{legalDoc.effective}</span>
            <span>{legalDoc.updated}</span>
          </div>
        </header>

        <div className="legal-layout">
          <aside className="legal-toc" aria-label="Table of contents">
            <div className="legal-toc-card">
              <h2>Table of contents</h2>
              <nav>
                {legalDoc.sections.map((section) => (
                  <a href={`#${section.id}`} key={section.id}>
                    <span>{String(section.number).padStart(2, "0")}</span>
                    {section.title}
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          <article className="legal-document">
            {legalDoc.sections.map((section) => (
              <section className="legal-section" id={section.id} key={section.id}>
                <h2><span>{String(section.number).padStart(2, "0")}</span>{section.title}</h2>
                <div className="legal-section-body">
                  {section.blocks.map((block, index) => {
                    if (block.type === "subheading") return <h3 key={index}>{block.text}</h3>;
                    if (block.type === "list") {
                      return (
                        <ul key={index}>
                          {block.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
                        </ul>
                      );
                    }
                    return <p key={index}>{block.text}</p>;
                  })}
                </div>
              </section>
            ))}
          </article>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
